import type { BetSlipState, UpdateStakeCursorPositionPayload } from '../types';

const updateStakeCursorPosition = (
  state: BetSlipState,
  { selectionStart, selectionEnd }: UpdateStakeCursorPositionPayload
): BetSlipState => ({
  ...state,
  stakeCursorStartPosition: selectionStart,
  stakeCursorEndPosition: selectionEnd
});

export default updateStakeCursorPosition;
